

document.querySelectorAll('details.mega-menu').forEach(details => {
  details.addEventListener('toggle', () => {
    if (!details.open) {
      // When closing, force a reset of the animation
      const items = details.querySelectorAll('ul.mega-menu__list.page-width li.top_part');
      items.forEach(item => {
        // Force reflow to reset animation
        item.style.animation = 'none';
        void item.offsetWidth; // Trigger reflow
        item.style.animation = null;
      });
    }
  });
});






let items = document.querySelector(".header__inline-menu").querySelectorAll("details");

items.forEach(item => {
  let hoverTimeout;
  
  // Function to open menu
  const openMenu = () => {
    clearTimeout(hoverTimeout);
    item.setAttribute("open", true);
  };
  
  // Function to close menu with delay
  const closeMenu = () => {
    hoverTimeout = setTimeout(() => {
      item.removeAttribute("open");
    }, 100); // Small delay to prevent flickering
  };
  
  // Open on hover over the summary/trigger
  item.addEventListener("mouseenter", openMenu);
  
  // Close when leaving the entire details element
  item.addEventListener("mouseleave", closeMenu);
  
  // Keep open when hovering over the mega menu content
  const megaMenuContent = item.querySelector(".mega-menu__content");
  if (megaMenuContent) {
    megaMenuContent.addEventListener("mouseenter", openMenu);
    megaMenuContent.addEventListener("mouseleave", closeMenu);
  }
  
  // Prevent default click behavior on desktop
  const summary = item.querySelector("summary");
  if (summary) {
    summary.addEventListener("click", (e) => {
      if (window.innerWidth >= 990) { // Desktop breakpoint
        e.preventDefault();
      }
    });
  }
});
